import { Nullable } from '@clearverify/types';

import { VerifierDetailInfoFragment, VerifierStaffItemFragment } from 'src/api';

import { VerifyAutomaticModalFormAddressFields, VerifyAutomaticModalFormFields } from '../types';

export const getVerifyAutomaticModalFormInitialValues = (
  verifier: Nullable<VerifierDetailInfoFragment>,
  verifierAdmin: Nullable<VerifierStaffItemFragment>,
) => {
  return {
    [VerifyAutomaticModalFormFields.legalBusinessName]:
      verifier?.type === 'Commercial' ? verifier.legalBusinessName : verifier?.governmentEntityName,
    [VerifyAutomaticModalFormFields.FEIN]: verifier?.fEIN,
    [VerifyAutomaticModalFormFields.contactPhone]: verifier?.contactPhone,
    [VerifyAutomaticModalFormFields.websiteURL]: verifier?.websiteURL,

    [VerifyAutomaticModalFormFields.firstName]: verifierAdmin?.user.firstName,
    [VerifyAutomaticModalFormFields.lastName]: verifierAdmin?.user.lastName,
    [VerifyAutomaticModalFormFields.phoneNumber]: verifierAdmin?.user.phoneNumber,
    [VerifyAutomaticModalFormFields.email]: verifierAdmin?.user.email,

    [VerifyAutomaticModalFormFields.address]: {
      [VerifyAutomaticModalFormAddressFields.street]: verifier?.address?.street ?? '',
      [VerifyAutomaticModalFormAddressFields.city]: verifier?.address?.city ?? '',
      [VerifyAutomaticModalFormAddressFields.state]: verifier?.address?.state ?? '',
      [VerifyAutomaticModalFormAddressFields.county]: verifier?.address?.county ?? '',
      [VerifyAutomaticModalFormAddressFields.zipCode]: verifier?.address?.zipCode ?? '',
    },
  };
};
